(function () {

  /**
   * Show an error message underneath the Montering fields.
   */
  function showError(addon, message) {
    const error = addon.querySelector('[data-montering-error]');

    if (!error) return;

    error.textContent = message || '';
    error.hidden = !message;
  }

  /**
   * Hide/show accelerated checkout buttons.
   *
   * When Montering is selected we hide Buy it now / Shop Pay etc.
   * This ensures the customer uses the normal Add to Cart flow so
   * the Montering information can be validated and saved.
   */
  function setDynamicCheckoutVisibility(container, monteringSelected) {
    const dynamicCheckout = container.querySelector(
      '[data-montering-dynamic-checkout]'
    );

    if (!dynamicCheckout) return;

    dynamicCheckout.style.display = monteringSelected ? 'none' : '';
  }

  /**
   * Reveal or hide the Montering fields.
   */
  function updateAddonVisibility(addon, container) {
    const toggle = addon.querySelector('[data-montering-toggle]');
    const fields = addon.querySelector('[data-montering-fields]');

    if (!toggle || !fields) return;

    if (toggle.checked) {
      fields.hidden = false;
      setDynamicCheckoutVisibility(container, true);
    } else {
      fields.hidden = true;
      setDynamicCheckoutVisibility(container, false);
      showError(addon, '');
    }
  }

  /**
   * Update the displayed Montering price
   * using the selected Shopify variant.
   */
  function updateMonteringPrice(addon) {
    const locationSelect = addon.querySelector(
      '[data-montering-location]'
    );

    const priceDisplay = addon.querySelector(
      '[data-montering-price]'
    );

    if (!locationSelect || !priceDisplay) return;

    const selectedOption =
      locationSelect.options[locationSelect.selectedIndex];

    if (!selectedOption || !selectedOption.value) {
      return;
    }

    const formattedPrice =
      selectedOption.dataset.priceFormatted || '';

    if (formattedPrice) {
      priceDisplay.textContent = `(+${formattedPrice})`;
    }
  }

  /**
   * Validate Montering information before Add to Cart.
   */
  function validateMontering(addon) {
    const toggle = addon.querySelector('[data-montering-toggle]');
    const locationSelect = addon.querySelector(
      '[data-montering-location]'
    );
    const registration = addon.querySelector(
      '[data-montering-registration]'
    );

    if (!toggle || !toggle.checked) {
      return {
        valid: true,
        selected: false
      };
    }

    if (!locationSelect || !locationSelect.value) {
      showError(addon, 'Välj en monteringsplats.');

      if (locationSelect) {
        locationSelect.focus();
      }

      return {
        valid: false,
        selected: true
      };
    }

    if (!registration || !registration.value.trim()) {
      showError(addon, 'Fyll i registreringsnummer.');

      if (registration) {
        registration.focus();
      }

      return {
        valid: false,
        selected: true
      };
    }

    const selectedOption =
      locationSelect.options[locationSelect.selectedIndex];

    if (!selectedOption) {
      showError(addon, 'Välj en monteringsplats.');

      return {
        valid: false,
        selected: true
      };
    }

    const variantId = parseInt(locationSelect.value, 10);

    if (!variantId) {
      showError(addon, 'Ogiltig monteringsplats. Försök igen.');

      return {
        valid: false,
        selected: true
      };
    }

    showError(addon, '');

    return {
      valid: true,
      selected: true,
      variantId: variantId,
      location:
        selectedOption.dataset.location ||
        selectedOption.textContent.trim(),
      registration: registration.value.trim().toUpperCase()
    };
  }

  /**
   * Add the selected Montering variant.
   *
   * The variant ID comes directly from the selected
   * Shopify Montering product variant.
   *
   * Properties remain visible in Shopify Admin orders.
   */
  async function addMontering(
    variantId,
    location,
    registration
  ) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: 1,
            properties: {
              Monteringsplats: location,
              Registreringsnummer: registration
            }
          }
        ]
      })
    });

    if (!response.ok) {
      const errorText = await response.text();

      console.error(
        '[Montering] Kunde inte lägga till montering:',
        errorText
      );

      throw new Error(errorText);
    }

    return response.json();
  }

  /**
   * Initialise one Montering block.
   */
  function initialiseAddon(addon) {
    if (!addon || addon.dataset.monteringInitialised === 'true') {
      return;
    }

    addon.dataset.monteringInitialised = 'true';

    const toggle = addon.querySelector('[data-montering-toggle]');

    const locationSelect = addon.querySelector(
      '[data-montering-location]'
    );

    const registration = addon.querySelector(
      '[data-montering-registration]'
    );

    const container =
      addon.closest('.product-information--inner') ||
      addon.closest('.product-information') ||
      document;

    const productForm =
      container.querySelector('[data-montering-product-form]') ||
      container.querySelector(
        'form[data-type="add-to-cart-form"]'
      );

    const submitButton =
      container.querySelector('[data-montering-submit]') ||
      container.querySelector(
        'button[type="submit"][name="add"]'
      );

    if (!toggle) {
      return;
    }

    /**
     * Always start unchecked.
     */
    toggle.checked = false;

    /**
     * Always reset the dropdown to "Välj plats".
     */
    if (locationSelect) {
      locationSelect.selectedIndex = 0;
    }

    /**
     * Always clear registration field on load.
     */
    if (registration) {
      registration.value = '';
    }

    updateAddonVisibility(addon, container);

    /**
     * Checkbox only reveals the fields.
     * It does NOT add anything to the cart.
     */
    toggle.addEventListener('change', function () {
      updateAddonVisibility(addon, container);
    });

    /**
     * Registration number:
     * convert text to uppercase.
     */
    if (registration) {
      registration.addEventListener('input', function () {
        registration.value =
          registration.value.toUpperCase();

        if (registration.value.trim()) {
          showError(addon, '');
        }
      });
    }

    /**
     * Installation location:
     *
     * - clear validation error
     * - update displayed price using selected variant price
     */
    if (locationSelect) {
      locationSelect.addEventListener('change', function () {
        if (locationSelect.value) {
          showError(addon, '');
          updateMonteringPrice(addon);
        }
      });
    }

    /**
     * If we cannot locate the actual Shopify product form,
     * stop here rather than interfering with the theme.
     */
    if (!productForm) {
      console.warn(
        '[Montering] Kunde inte hitta produktformuläret.'
      );
      return;
    }

    /**
     * Intercept Add to Cart only when Montering is selected.
     */
    productForm.addEventListener(
      'submit',
      async function (event) {

        /**
         * Second submission:
         * allow the theme's normal Add to Cart logic.
         */
        if (productForm.dataset.monteringBypass === 'true') {
          delete productForm.dataset.monteringBypass;
          return;
        }

        /**
         * No Montering selected:
         * leave normal Shopify behaviour completely untouched.
         */
        if (!toggle.checked) {
          return;
        }

        const validation = validateMontering(addon);

        /**
         * Invalid Montering fields:
         * stop main product submission.
         */
        if (!validation.valid) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }

        /**
         * Pause normal product submission while
         * the Montering line is added.
         */
        event.preventDefault();
        event.stopImmediatePropagation();

        if (submitButton) {
          submitButton.disabled = true;
          submitButton.setAttribute('aria-busy', 'true');
        }

        try {

          /**
           * Add the actual selected Shopify Montering variant.
           */
          await addMontering(
            validation.variantId,
            validation.location,
            validation.registration
          );

          /**
           * Let the next form submission pass through normally.
           */
          productForm.dataset.monteringBypass = 'true';

          if (submitButton) {
            submitButton.disabled = false;
            submitButton.removeAttribute('aria-busy');
          }

          /**
           * Submit the normal Rimgard product through the theme.
           */
          if (typeof productForm.requestSubmit === 'function') {
            if (submitButton) {
              productForm.requestSubmit(submitButton);
            } else {
              productForm.requestSubmit();
            }
          } else {
            productForm.submit();
          }

        } catch (error) {
          console.error(
            '[Montering] Fel vid tillägg av montering:',
            error
          );

          showError(
            addon,
            'Montering kunde inte läggas till. Försök igen.'
          );

          if (submitButton) {
            submitButton.disabled = false;
            submitButton.removeAttribute('aria-busy');
          }
        }
      },
      true
    );
  }

  /**
   * Initialise all Montering blocks.
   */
  function init() {
    document
      .querySelectorAll('[data-montering-addon]')
      .forEach(initialiseAddon);
  }

  /**
   * Normal page load.
   */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /**
   * Shopify Theme Editor can reload the section dynamically.
   */
  document.addEventListener(
    'shopify:section:load',
    init
  );

})();